import { isNumber } from "util";
import { parseTimeFromSeconds } from "../../helpers";
export const mapGameTime = (x) => {
    x.gameTime = getGameTime(x);
    return x;
};
const getGameTime = (x) => {
    if (!x.liveGameState || !isNumber(x.liveGameState.gameTime)) {
        return "";
    }
    return isEventInHalfTime(x.liveGameState) ? "" : parseTimeFromSeconds(x.liveGameState.gameTime);
};
const isEventInHalfTime = (liveGameState) => {
    return liveGameState.gamePart && liveGameState
        .gamePart
        .startsWith("Break");
};
//# sourceMappingURL=mapGameTime.js.map